import { render, staticRenderFns } from "./NewContractManager.vue?vue&type=template&id=337024fc&scoped=true&"
import script from "./NewContractManager.vue?vue&type=script&lang=js&"
export * from "./NewContractManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337024fc",
  null
  
)

export default component.exports